// extracted by mini-css-extract-plugin
export default {"hoverWrapper":"ScaleImage_hoverWrapper__lPoVY","scaleImage":"ScaleImage_scaleImage__BGHMs"};